import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "e46d1529-abce-4248-aaba-29e741afab31",
    content: "11 dB",
    options: {},
  },
  {
    id: "5362f674-3281-4a19-83cd-5fbdad410086",
    content: "33 dB",
    options: {},
  },
  {
    id: "fd1aba9e-043a-40cf-ab2f-d5e4b24cd1f7",
    content: "45 dB",
    options: {},
  },
  {
    id: "37adf7f9-2e1b-4f7f-92af-d7384f63104d",
    content: "22 dB",
    options: {},
  },
  {
    id: "eb88f070-cea6-4765-998e-133f02ba81c0",
    content: "39 dB",
    options: {},
  },
  {
    id: "c3d61e39-44c3-4ca9-9c42-c522d5c9f808",
    content: "110 dB",
    options: {},
  },
];

export const task: Task = {
  id: "cdff0d5a-902a-4a32-a20f-f065b320749e",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["37adf7f9-2e1b-4f7f-92af-d7384f63104d"],
};
